import React, { useEffect, useState } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import { useAuth } from '../context/AuthContext'; // Import useAuth

// Import the CSS for DataTables
import 'datatables.net-dt/css/dataTables.dataTables.css';

DataTable.use(DT);

const MasterMatrixPage = () => {
  const [data, setData] = useState([]);
  const { api } = useAuth(); // Use our configured axios instance

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/matriz-base/');
        setData(response.data);
      } catch (error) {
        console.error('Error fetching matriz base data:', error);
        // Here you could add more robust error handling, like showing a message to the user
      }
    };

    fetchData();
  }, [api]);

  const columns = [
    { title: 'Grupo de Delitos', data: 'grupo_delitos' },
    { title: 'Categoría', data: 'categoria' },
    { title: 'Ley', data: 'ley' },
    { title: 'Artículo', data: 'articulo' },
    { title: 'Título', data: 'titulo', className: 'td-wrap' },
    { title: 'Procesos Expuestos', data: 'procesos_expuestos', className: 'td-wrap' },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h1>Matriz Maestra</h1>
      <p>Esta es la base de conocimiento central que alimenta las matrices de riesgo.</p>
      
      <div style={{ marginTop: '20px' }}>
        <DataTable
          className="display"
          data={data}
          columns={columns}
        />
      </div>
    </div>
  );
};

export default MasterMatrixPage; 